module.exports = __webpack_public_path__ + "img/MELA_B.e8c3f2c0.png";